module.exports = __webpack_public_path__ + "static/img/27.89aea58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/27.png
// module id = oYvP
// module chunks = 1